import Entity from "../entity";

export default class OfferTimeSlot extends Entity<number> {
  startTime: Date;
  endTime: Date;
  offerDateSlotId:number=0;
}
